/**
 * Tive API
 *
 * Contact: support@tive.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { HideSensorDataModel } from '../model/hideSensorDataModel';
// @ts-ignore
import { SensorDataQueryModel } from '../model/sensorDataQueryModel';
// @ts-ignore
import { Table } from '../model/table';
// @ts-ignore
import { TimeSeriesColumnModel } from '../model/timeSeriesColumnModel';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class TimeSeriesTableService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Perform the action for hiding location point (Role Permissions Required: CanHideLocationData)
   * @endpoint post /api/timeseries/hidelocationdata
   * @param xTiveAccountId Account Id
   * @param hideSensorDataModel
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiTimeseriesHidelocationdataPost(
    xTiveAccountId?: number,
    hideSensorDataModel?: HideSensorDataModel,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<boolean>;
  public apiTimeseriesHidelocationdataPost(
    xTiveAccountId?: number,
    hideSensorDataModel?: HideSensorDataModel,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<boolean>>;
  public apiTimeseriesHidelocationdataPost(
    xTiveAccountId?: number,
    hideSensorDataModel?: HideSensorDataModel,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<boolean>>;
  public apiTimeseriesHidelocationdataPost(
    xTiveAccountId?: number,
    hideSensorDataModel?: HideSensorDataModel,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/timeseries/hidelocationdata`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: hideSensorDataModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Retrieves the columns and the corresponding types  available for the sensor data timeseries
   * @endpoint get /api/timeseries/sensordata/columns
   * @param xTiveAccountId Account Id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiTimeseriesSensordataColumnsGet(
    xTiveAccountId?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<Array<TimeSeriesColumnModel>>;
  public apiTimeseriesSensordataColumnsGet(
    xTiveAccountId?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<Array<TimeSeriesColumnModel>>>;
  public apiTimeseriesSensordataColumnsGet(
    xTiveAccountId?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<Array<TimeSeriesColumnModel>>>;
  public apiTimeseriesSensordataColumnsGet(
    xTiveAccountId?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/timeseries/sensordata/columns`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<TimeSeriesColumnModel>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Performs a query against the sensor data timeseries
   * @endpoint post /api/timeseries/sensordata
   * @param xTiveAccountId Account Id
   * @param sensorDataQueryModel A list of sensor data queries to make
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public apiTimeseriesSensordataPost(
    xTiveAccountId?: number,
    sensorDataQueryModel?: Array<SensorDataQueryModel>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<{ [key: string]: Table }>;
  public apiTimeseriesSensordataPost(
    xTiveAccountId?: number,
    sensorDataQueryModel?: Array<SensorDataQueryModel>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<{ [key: string]: Table }>>;
  public apiTimeseriesSensordataPost(
    xTiveAccountId?: number,
    sensorDataQueryModel?: Array<SensorDataQueryModel>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<{ [key: string]: Table }>>;
  public apiTimeseriesSensordataPost(
    xTiveAccountId?: number,
    sensorDataQueryModel?: Array<SensorDataQueryModel>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?:
        | 'application/json;odata.metadata=minimal;odata.streaming=true'
        | 'application/json;odata.metadata=minimal;odata.streaming=false'
        | 'application/json;odata.metadata=minimal'
        | 'application/json;odata.metadata=full;odata.streaming=true'
        | 'application/json;odata.metadata=full;odata.streaming=false'
        | 'application/json;odata.metadata=full'
        | 'application/json;odata.metadata=none;odata.streaming=true'
        | 'application/json;odata.metadata=none;odata.streaming=false'
        | 'application/json;odata.metadata=none'
        | 'application/json;odata.streaming=true'
        | 'application/json;odata.streaming=false'
        | 'application/json'
        | 'application/xml'
        | 'text/plain'
        | 'application/octet-stream'
        | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    if (xTiveAccountId !== undefined && xTiveAccountId !== null) {
      localVarHeaders = localVarHeaders.set('x-tive-account-id', String(xTiveAccountId));
    }

    // authentication (Bearer) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Bearer',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    // authentication (Tive_Api_Key) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'Tive_Api_Key',
      'TiveApiKey',
      localVarHeaders,
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept([
        'application/json;odata.metadata=minimal;odata.streaming=true',
        'application/json;odata.metadata=minimal;odata.streaming=false',
        'application/json;odata.metadata=minimal',
        'application/json;odata.metadata=full;odata.streaming=true',
        'application/json;odata.metadata=full;odata.streaming=false',
        'application/json;odata.metadata=full',
        'application/json;odata.metadata=none;odata.streaming=true',
        'application/json;odata.metadata=none;odata.streaming=false',
        'application/json;odata.metadata=none',
        'application/json;odata.streaming=true',
        'application/json;odata.streaming=false',
        'application/json',
        'application/xml',
        'text/plain',
        'application/octet-stream',
        'text/json',
      ]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json;odata.metadata=minimal;odata.streaming=true',
      'application/json;odata.metadata=minimal;odata.streaming=false',
      'application/json;odata.metadata=minimal',
      'application/json;odata.metadata=full;odata.streaming=true',
      'application/json;odata.metadata=full;odata.streaming=false',
      'application/json;odata.metadata=full',
      'application/json;odata.metadata=none;odata.streaming=true',
      'application/json;odata.metadata=none;odata.streaming=false',
      'application/json;odata.metadata=none',
      'application/json;odata.streaming=true',
      'application/json;odata.streaming=false',
      'application/json',
      'application/xml',
      'text/plain',
      'application/json-patch+json',
      'text/json',
      'application/*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/timeseries/sensordata`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<{ [key: string]: Table }>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: sensorDataQueryModel,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }
}
